import React from 'react';
import { STOCKS, formatPrice } from '../../constants/stocks';

function StockPortfolio({ holdings, prices, onStockClick }) {
  if (!holdings || Object.keys(holdings).length === 0) {
    return (
      <div className="stock-portfolio-empty">
        <p>You don't own any stocks yet.</p>
        <p>Switch to the Market tab to start trading!</p>
      </div>
    );
  }

  // Calculate totals
  let totalValue = 0;
  let totalCostBasis = 0;
  const positions = [];

  for (const [stockId, holding] of Object.entries(holdings)) {
    const stock = STOCKS.find(s => s.id === stockId);
    if (!stock || holding.shares <= 0) continue;

    const priceData = prices?.[stock.ticker];
    const currentPrice = priceData?.price || 0;
    const currentValue = holding.shares * currentPrice;
    const pnl = currentValue - holding.costBasis;
    const pnlPercent = holding.costBasis > 0 ? ((pnl / holding.costBasis) * 100) : 0;

    totalValue += currentValue;
    totalCostBasis += holding.costBasis;

    positions.push({
      stock,
      holding,
      currentPrice,
      currentValue,
      pnl,
      pnlPercent,
      priceData,
    });
  }

  // Sort by current value descending
  positions.sort((a, b) => b.currentValue - a.currentValue);

  const totalPnL = totalValue - totalCostBasis;
  const totalPnLPercent = totalCostBasis > 0 ? ((totalPnL / totalCostBasis) * 100) : 0;

  return (
    <div className="stock-portfolio">
      {/* Summary card */}
      <div className="stock-portfolio-summary">
        <div className="stock-portfolio-stat">
          <span className="stock-portfolio-stat-label">Portfolio Value</span>
          <span className="stock-portfolio-stat-value">${totalValue.toFixed(2)}</span>
        </div>
        <div className="stock-portfolio-stat">
          <span className="stock-portfolio-stat-label">Total Invested</span>
          <span className="stock-portfolio-stat-value">${totalCostBasis.toFixed(2)}</span>
        </div>
        <div className="stock-portfolio-stat">
          <span className="stock-portfolio-stat-label">Total P&L</span>
          <span className={`stock-portfolio-stat-value ${totalPnL >= 0 ? 'positive' : 'negative'}`}>
            {totalPnL >= 0 ? '+' : ''}${Math.abs(totalPnL).toFixed(2)} ({totalPnLPercent.toFixed(1)}%)
          </span>
        </div>
      </div>

      {/* Positions list */}
      <div className="stock-portfolio-positions">
        <h4 className="stock-portfolio-positions-title">Your Positions</h4>
        {positions.map(({ stock, holding, currentPrice, currentValue, pnl, pnlPercent }) => {
          return (
            <div
              key={stock.id}
              className="stock-position-card"
              onClick={() => onStockClick(stock)}
            >
              <div className="stock-position-left">
                <span className="stock-position-icon">{stock.icon}</span>
                <div className="stock-position-info">
                  <span className="stock-position-name">{stock.name}</span>
                  <span className="stock-position-shares">
                    {holding.shares.toFixed(4)} shares @ {formatPrice(holding.avgPrice)}
                  </span>
                </div>
              </div>
              <div className="stock-position-right">
                <span className="stock-position-value">${currentValue.toFixed(2)}</span>
                <span className={`stock-position-pnl ${pnl >= 0 ? 'positive' : 'negative'}`}>
                  {pnl >= 0 ? '+' : ''}${Math.abs(pnl).toFixed(2)} ({pnlPercent.toFixed(1)}%)
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default StockPortfolio;
